import { Avatar } from 'antd'
import styled from 'styled-components'

export const LoginScreenContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`

export const LoginFormContainer = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow:
    rgba(6, 24, 44, 0.4) 0px 0px 0px 2px,
    rgba(6, 24, 44, 0.65) 0px 4px 6px -1px,
    rgba(255, 255, 255, 0.08) 0px 1px 0px inset;
  gap: 20px;
  padding: 20px 0px;
   @media (max-width: 1200px) {
      width: 90%;
  }
`

export const LoginFormTitle = styled.h1`
  font-size: 1.5em;
`

export const LoginFormAvatar = styled(Avatar)`
  width: 150px;
  height: 150px;
  background-color: white;
  & svg {
    width: 150px;
    height: 150px;
    fill: grey;
  }
`

export const LoginFormControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & .loginTextButton {
    margin-top: 15px;
  }
`
